import { render, staticRenderFns } from "./WineWinEdit.vue?vue&type=template&id=4bfa03d6&scoped=true"
import script from "./WineWinEdit.vue?vue&type=script&lang=js"
export * from "./WineWinEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa03d6",
  null
  
)

export default component.exports